export const MAXIMUM_USERS_AWAY_DEFAULT_PERCENTAGE = 90
